'use client'

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { useCareAndShareConfigs } from '@/hooks/react-query/care-and-share/use-configs'
import { useRouter } from '@/i18n/navigation'
import { ImageHelper } from '@/lib/helpers/image.helper'
import Autoplay from 'embla-carousel-autoplay'
// import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { useCareShareTabsContext } from '../hooks/care-share-tabs-context'

export const CareAndShareBanner = () => {
  const { data } = useCareAndShareConfigs()

  const router = useRouter()
  const { handleTabChange } = useCareShareTabsContext()
  const handleBannerClick = (slug: string) => {
    // Slug chứa '/' là đường dẫn sang page khác, không phải tab
    if (slug.includes('/')) {
      router.replace(slug.startsWith('/') ? slug : `/${slug}`)
      return
    }
    handleTabChange(slug)
    document.getElementById('care-share-other-products')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }

  if (!data?.hero_banners?.length) {
    return null
  }

  return (
    <section
      className='relative w-full max-sm:min-h-[500px] lg:min-h-[500px]'
      aria-label='Care and Share Banner Slideshow'
    >
      <Carousel
        opts={{
          loop: true,
        }}
        plugins={[
          Autoplay({
            delay: 3000,
            stopOnInteraction: false,
            stopOnMouseEnter: true,
          }),
        ]}
      >
        <CarouselContent className='ml-0 h-full w-full'>
          {data?.hero_banners.map((slide, index) => {
            if (!slide.image || !slide.mb_image || !slide.slug) {
              return null
            }
            return (
              <CarouselItem
                key={index}
                className='relative h-full w-full cursor-pointer p-0'
                onClick={() => handleBannerClick(slide.slug)}
              >
                <picture>
                  <source
                    srcSet={ImageHelper.getImageUrl(slide.mb_image)}
                    media='(max-width: 991px)'
                  />
                  <Image
                    src={ImageHelper.getImageUrl(slide.image)}
                    alt={slide.alt || ''}
                    width={1920}
                    height={600}
                    className='w-full object-cover'
                    priority={index === 0}
                    loading={index === 0 ? 'eager' : 'lazy'}
                  />
                </picture>
              </CarouselItem>
            )
          })}
        </CarouselContent>
        <CarouselNavigation />
      </Carousel>
    </section>
  )
}

function CarouselNavigation() {
  return (
    <>
      <CarouselPrevious
        className='absolute -left-4 top-1/2 h-10 w-10 -translate-y-1/2 border-none invert max-lg:hidden lg:left-1'
        variant='outline-neutral'
        hideIfStart
      />
      <CarouselNext
        className='absolute -right-4 top-1/2 h-10 w-10 -translate-y-1/2 border-none invert max-lg:hidden lg:right-1'
        variant='outline-neutral'
        hideIfEnd
      />
    </>
  )
}
